import { usePage } from '@inertiajs/react'
import { useCan } from '@/shared/hooks/useCan'
import { Resources, Actions } from '@/shared/rbac'
import { t } from '@/shared/lib/i18n'
import { notificationPreferencePath } from '@/shared/lib/routes'
import type { SharedProps } from '@/shared/types/SharedProps'
import type WebNotificationPreferencesPage from '@/shared/types/web/WebNotificationPreferencesPage'
import PreferenceForm from './PreferenceForm'

interface NotificationPreferencesPageProps {
  notificationPreferencesPage: WebNotificationPreferencesPage
}

type PageProps = SharedProps & NotificationPreferencesPageProps

const NotificationPreferencesIndex = () => {
  const { notificationPreferencesPage } = usePage<PageProps>().props
  const canSubmit = useCan(Resources.NOTIFICATION_PREFERENCES, Actions.UPDATE)

  return (
    <div className="mx-auto max-w-3xl space-y-6 px-4 py-8">
      <header className="space-y-1">
        <h1 className="text-2xl font-semibold tracking-tight">
          {t('notificationPreferences.pageTitle')}
        </h1>
        <p className="text-sm text-muted-foreground">{t('notificationPreferences.pageSubtitle')}</p>
      </header>

      <PreferenceForm
        notificationPreferencesPage={notificationPreferencesPage}
        patchPath={notificationPreferencePath()}
        canSubmit={canSubmit}
      />
    </div>
  )
}

export default NotificationPreferencesIndex
